<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <template>
          <div class="title-box">请根据订单实际情况进行核价，无需考虑发票价格</div>
          <el-row :gutter="20">
            <el-form ref="form" :model="form" :rules="rules" label-position="top">
              <el-col :span="24">
                <el-form-item label="运单金额：" prop="fee">
                  <el-input
                    v-model="form.fee"
                    clearable
                    style="width: 100%"
                    autocomplete="off"
                    placeholder="请输入运费金额（不含发票税点）">
                    <template slot="prefix">￥</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="确认金额：" prop="fee1">
                  <el-input
                    v-model="form.fee1"
                    clearable
                    style="width: 100%"
                    autocomplete="off"
                    placeholder="请再次输入价格">
                    <template slot="prefix">￥</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </template>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import CustomTable from "@/components/CustomTable.vue";
import { validatePrice } from "@/utils/validate";
import {feeSetFreight} from "@/views/CustomerServiceWorkbench/PendingPriceOrder/api";
export default {
  name: "reviewPrice",
  components: {
    CustomTable,
    DialogContainer,
  },
  data() {
    var validatePriceTong = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入金额'));
      } else if (value !== this.form.fee) {
        callback(new Error('两次输入金额不一致!'));
      } else {
        callback();
      }
    };
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "运单价格调整",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        fee: "",
        fee1: "",
        orderId: "",
        pass: false,
      },
      detail: {},
      rules: {
        fee: [
          { required: true, message: "运费金额不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        fee1: [
          { required: true, message: "确认金额不能为空" },
          { validator: validatePrice, trigger: "blur" },
          { validator: validatePriceTong, trigger: "blur" },
        ],
      },
      isDetail: false,
    };
  },
  mounted() {},
  methods: {
    init(row) {
      this.form.orderId = row.orderId;
      this.dialogObj.show = true;
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          feeSetFreight({
            fee: this.form.fee,
            orderId: this.form.orderId,
            pass: this.form.pass,
          })
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("金额设置成功");
                this.$parent.handleAddOrEditSuccess("edit");
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .order-detail-box {
    display: flex;
    width: 100%;
    height: 0.8rem;
    background: #f7fbff;
    padding: 0.1rem;
    border-radius: 0.08rem;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
    .label-val {
      width: 33.3%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      .label-1 {
        color: #8c8c8c;
        font-size: 0.12rem;
        padding-bottom: 0.06rem;
      }
      .value-1 {
        color: #434343;
      }
    }
    .label-val:after {
      content: "";
      position: absolute;
      right: 0;
      width: 0.01rem;
      height: 0.26rem;
      background: #dce5f5;
    }
    .label-val:nth-last-of-type(1):after {
      display: none;
    }
  }
  .title-box {
    padding: 0rem 0 0.1rem;
    color: #000000;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .common-info-box {
    padding: 0.1rem;
    box-sizing: border-box;
    background: #f7f8fb;
    line-height: 0.24rem;
    border-radius: 0.08rem;
  }
  .common-image-box {
    margin-bottom: 0;
    margin-top: 0.04rem;
  }
  .invice-info {
    line-height: 0.24rem;
    margin-bottom: 0.2rem;
  }
  .radio-box {
    display: flex;
    align-items: center;
    span {
      font-size: 0.12rem;
      color: #8c8c8c;
    }
  }
}
</style>
